/**
 * 初期設定
 *
 * window.SCREEN_SETTINGS → Lang/ja/setting.phpを参照
 * window.ITEM_SETTINGS → Lang/ja/items.phpを参照
 */

$(function() {
    init();

    async function init()
    {
        window.SCREEN_SETTINGS = await window.getLangSetting('setting');
        window.ITEM_SETTINGS = await window.getLangSetting('items');
        window.MESSAGE_SETTINGS = await window.getLangSetting('messages');
    }
});